import React from 'react';
import { connect } from 'react-redux';
import Dropzone from "react-dropzone";

import { postCard } from '../../../actions/app/mpt/weeks';


import './Week/Week.css'

class CreateCard extends React.Component {
    state = {
        input: '',
        image: null,
        modif: false,
    };

    onDrop(file){
        this.setState({ image: file[0], modif: true })
    }

    addCard() {
        const { data, dispatch } = this.props;
        const { input, image } = this.state;
        if (input && image) {
            dispatch(postCard({ lastname: input, file: image }, data.id));
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.data.cards !== nextProps.data.cards) {
            this.setState({
                input: '',
                image: null,
                modif: false,
            });
        }
    }

    render() {
        const { input, image, modif } = this.state;
        return (
            <div>
                <div className="col-md-12">
                    <div className="col-md-2">
                        <input
                            value={input}
                            onChange={(t) => this.setState({ input:t.target.value, modif: true })}
                        />
                    </div>
                    <div className="col-md-2">
                        <Dropzone
                            onDrop={(acceptedFiles) =>
                                this.onDrop(acceptedFiles)
                            }
                            className="btn-warning dropzone text-center"
                        >
                            Upload
                        </Dropzone>
                    </div>
                    {
                        image &&
                        <div className="col-md-2">
                            <img
                                className="playerPicture"
                                src={image.preview}
                                alt=""
                            />
                        </div>
                    }
                    <div className="col-md-2">
                        <button
                            className={modif ? 'btn-warning' : 'btn-success'}
                            onClick={() => this.addCard()}
                        >
                            Add Card
                        </button>
                    </div>
                </div>
            </div>
        )
    }
}

export default connect(
    state => ({
        weeks: state.app.mpt.weeks.list,
    }),
    dispatch => ({ dispatch }),
)(CreateCard);



// WEBPACK FOOTER //
// ./src/pages/MPT/Creation/createCard.js